import Plot from 'react-plotly.js'

interface GaugeChartProps {
  value: number
  min?: number
  max?: number
  title?: string
  unit?: string
  height?: number
  thresholds?: {
    low: number
    high: number
  }
  className?: string
}

export default function GaugeChart({
  value,
  min = 0,
  max = 100,
  title,
  unit = '%',
  height = 200,
  thresholds = { low: 60, high: 85 },
  className
}: GaugeChartProps) {
  // Determine color based on value and thresholds
  const getColor = () => {
    if (value >= thresholds.high) return '#10b981'
    if (value >= thresholds.low) return '#f59e0b'
    return '#ef4444'
  }

  const trace = {
    type: 'indicator' as const,
    mode: 'gauge+number' as const,
    value: value,
    number: {
      suffix: unit,
      font: { size: 24, color: '#f1f5f9', family: 'JetBrains Mono' }
    },
    gauge: {
      axis: {
        range: [min, max],
        tickwidth: 1,
        tickcolor: '#475569',
        tickfont: { color: '#94a3b8', size: 10 }
      },
      bar: { color: getColor(), thickness: 0.8 },
      bgcolor: '#1e293b',
      borderwidth: 0,
      steps: [
        { range: [min, thresholds.low], color: '#fee2e2' + '20' },
        { range: [thresholds.low, thresholds.high], color: '#fef3c7' + '20' },
        { range: [thresholds.high, max], color: '#d1fae5' + '20' }
      ],
      threshold: {
        line: { color: '#ef4444', width: 2 },
        thickness: 0.75,
        value: thresholds.low
      }
    }
  }

  const layout = {
    height,
    margin: { t: title ? 30 : 10, r: 20, b: 10, l: 20 },
    paper_bgcolor: 'transparent',
    font: { color: '#94a3b8', family: 'Inter, sans-serif' },
    title: title ? {
      text: title,
      font: { color: '#e2e8f0', size: 12 }
    } : undefined
  }

  const config = {
    displayModeBar: false,
    responsive: true
  }

  return (
    <div className={className}>
      <Plot
        data={[trace]}
        layout={layout}
        config={config}
        style={{ width: '100%' }}
      />
    </div>
  )
}
